module.exports = {
  "debug": {
    "hello": "こんにちわ",
    "count": "数値は{{count}}です",
    "change_lang": "{{lang}}に変更",
    "changed": "変更しました",
  },

  "meta": {
    "title": "PIGUCHI - おうちの人ページ",
    "description": "預金やローンの金額はおうちの人ページで編集することができます。",
  },

  "currency": "{{count}}えん",
  "message": {
    "confirm_delete": "{{name}}を本当に削除しますか？",
    "saved": "保存しました",
  },
  "header": {
    "done": "完了",
    "save": "保存",
  },
  "index": {
    "title": "おうちの人ページ",
    "privacy_policy": "プライバシーポリシーが更新されました。こちらからご確認ください。",
    "privacy_policy_link": "https://piguchi.com/privacy_policy/",
    "setting": "の設定",
    "loan_request": "ローンの申請が届いています",
    "works": "やることリストの編集",
    "amount_account": "口座のお金の編集",
    "amount_loan": "ローン金額の編集",
    "user": "ユーザーの編集",
    "add_child": "新しいユーザーを追加",
  },
  "works": {
    "title": "やることリストの編集",
    "for_guardians_label": "ご家庭の方へ",
    "for_guardians_description_1": "当アプリは、お手伝いを習慣化することを目的としたアプリです。",
    "for_guardians_description_2": "アプリ内での金銭のやり取りは一切発生しません。お子様が獲得された「お小遣い」は、保護者の方とお子様の間でのやり取りを前提としたものになります、ご了承ください。",
    "todo_list_label": "やることリスト",
    "todo_list_description": "毎日やることと、報酬金額を決めてください。",
    "create_new": "新しくやることを追加する",
    "once": "1回",
    "edit": "編集する",
    "delete": "削除する",
  },
  "works_single": {
    "title": "やることの編集",
    "icon": "アイコン",
    "work_title": "タイトル",
    "placeholder": "ペコにえさをあげる (max 全角30)",
    "error_message": "タイトルが31文字以上です",
    "reward": "報酬金額 (1回あたり)",
    "change": "変更する",
  },
  "user": {
    "title": "ユーザーの編集",
    "user_name": "ユーザー名",
    "color_label": "着せ替えカラー",
    "blue": "ブルー",
    "yellow": "イエロー",
    "pink": "ピンク",
    "purple": "パープル",
    "green": "グリーン",
    "delete_user": "ユーザーを削除する",
    "confirm_delete": "このユーザーを本当に削除しますか？",
    "error_message": "10文字以内で設定してください",
  },
  "image_modal": {
    "title": "アイコンを選択",
  },
  "bank_edit": {
    "account_title": "口座のお金の編集",
    "loan_title": "ローンの編集",
    "current_account": "現在の口座残高",
    "current_loan": "現在のローン残高",
    "amount_label": "増やす/減らす金額",
    "amount_placeholder": "金額を入力してください",
    "increase": "増やす",
    "decrease": "減らす",
    "reason_label": "金額を増やす/減らす理由",
    "reason_placeholder_account": "(例)おじいちゃんからのおこづかい",
    "reason_placeholder_loan": "(例)おじいちゃんへのプレゼント",
    "edit_done": "お金を編集しました",
  },
  "loan": {
    "title": "ローンの審査",
    "amount": "希望借入金額",
    "purpose": "借りたい理由",
    "for_guardians_description_1": "毎月ローン合計額の1%が利子としてローン残高に加算されます。",
    "for_guardians_description_2": "借金をすることのリスクをお子様に十分説明された上、ローンの申請の受理を行ってください。",
    "approve": "ローン申請を受理する",
    "deny": "ローン申請を却下する",
    "approve_message": "ローン申請を受理しました",
    "deny_message": "ローン申請を却下しました",
  },
};